import { useState } from "react";
import { ChevronDown } from "lucide-react";

const KEY = "admin_collapsed";
const read = () => { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch { return {}; } };

export const Collapsible = ({ id, title, children }) => {
  const [open, setOpen] = useState(!read()[id]);
  const toggle = () => {
    const next = !open;
    localStorage.setItem(KEY, JSON.stringify({ ...read(), [id]: !next }));
    setOpen(next);
  };
  return (
    <div data-testid={`section-${id}`}>
      <button onClick={toggle} data-testid={`section-toggle-${id}`} aria-expanded={open}
        className="w-full flex items-center justify-between px-6 py-2 border-b border-white/10 bg-[#0d0d0d] hover:bg-[#141414] transition-colors no-print">
        <span className="label">{title}</span>
        <ChevronDown className={`w-4 h-4 text-neutral-500 transition-transform duration-200 ${open ? "" : "-rotate-90"}`} />
      </button>
      {open && children}
    </div>
  );
};
